import { render, staticRenderFns } from "./PbReplacementEditor.vue?vue&type=template&id=46eb3ad6&"
import script from "./PbReplacementEditor.vue?vue&type=script&lang=js&"
export * from "./PbReplacementEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports